module.exports = __webpack_public_path__ + "static/antd-skeleton-list-ca4f8a13cbe95423f756450a63ff22d8.gif";